import { render } from "./onePurchase.vue?vue&type=template&id=2c19aba8"
import script from "./onePurchase.vue?vue&type=script&lang=js"
export * from "./onePurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__